module.exports = __webpack_public_path__ + "static/media/chanel_2.df814f99.jpg";